<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { mapGetters, mapActions, mapState } from "vuex";
import { ModelListSelect } from "vue-search-select";
/**
 * Advanced table component
 */
export default {
  page: {
    title: "User Roles",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    ModelListSelect,
  },
  data() {
    return {
      title: "System User Roles And Permissions",
      items: [
        {
          text: "Advanced Settings",
          href: "#/",
        },
        {
          text: "Role Permisstions",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      modal_id: "",
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "role_field",
          sortable: true,
          label: "ROLE NAME",
        },

        {
          sortable: false,
          key: "actions",
          label: "ACTIONS",
        },
      ],
      existingRole: [],
      nameError: "",

      // Value from user input for adding position
      data: {
        name: "",
        branch_id: "All"
      },
      // edit position
      editdata: {
        new_name: "",
        id: "",
        branch_id: ""
      },
      // delete position
      deletedata: {
        name: "",
        id: "",
      },
    };
  },
  computed: {
    // MAP STATE
    ...mapState("notification", [
      "notificationtype",
      "notification_message",
      "notification_show",
    ]),
    ...mapGetters("users", ["ROLES", "USER_SAVING", "GetAdminUser", "GetRoles"]),
    ...mapGetters("branch", ["GetBranch"]),
    ...mapGetters("auth", ["user_permissions" ,"userid","branch_id"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.ROLES ? this.ROLES.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.ROLES ? this.ROLES.length : 1;
  },
  watch: {
    notification_show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        this.closeModal(this.modal_id);
        if (this.notificationtype == "success") {
          this.$toast.success(this.notification_message.msg);
        } else {
          this.$toast.error(this.notification_message.msg);
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchUserRoles: "users/fetchUserRoles",
      Fetchrolepermissions: "users/fetchrolepermissionsPre",
      AddUserRole: "users/addUserRole",
      EditUserRole: "users/editUserRole",
      DeleteUserRole: "users/deleteUserRole",
      FetchAdminUsers: "users/fetchAdminUsers",
      FetchBranch: "branch/fetchBranch",
      AuthenticatedUser: "auth/Authenticated_user",
      FetchCheckedRoles: "users/CheckUserRoles",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },

    addRole(modalId) {
      this.modal_id = modalId;

      if (this.data.name === "") {
        this.nameError = "Role name field is required";
        return;
      } else {
        this.nameError = "";
      }
      if (this.branch_id == 0 && this.data.branch_id === "") {
        this.branchError = "Branch field is required";
        return;
      }else {
        this.branchError = "";
      }
      this.AddUserRole(this.data);
    },

    resetAddRole() {
      this.data.name = "";
      this.nameError = "";
      this.modal_id = "";
    },
    resetEditRole() {
      this.editdata.new_name = "";
      this.editdata.id = "";
      this.nameError = "";
      this.modal_id = "";
    },

    resetError() {
      this.nameError = "";
    },

    viewRolePermissions(data) {
      this.Fetchrolepermissions(data.id);
      this.$router.push(`role_permit/${btoa(data.id)}`);
    },

    //== close modal
    closeModal(modalId) {
      this.$nextTick(() => {
        this.$bvModal.hide(modalId);
      });
    },
  },
  created() {
    this.FetchUserRoles();
    this.FetchAdminUsers();
    this.FetchBranch();
    this.AuthenticatedUser();
    this.FetchCheckedRoles();
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <div>
                  <b-button class="float-end" variant="primary" v-b-modal.add-role-modal
                    ><i class="fa fa-plus"></i> Add Role</b-button
                  >

                  <!-- modal starts -->
                  <b-modal id="add-role-modal" hide-footer @hidden="resetAddRole">
                    <template #modal-title> Add New User Role </template>
                    <div class="form-group mb-3" v-if="branch_id == 0">
                    <label>Select Branch</label>
                    <select                       
                        v-model="data.branch_id"
                        class="form-control"                      
                      >
                        <option value="All">All</option>
                        <option  v-for="item in GetBranch" :value="item.Id" :key="item.Id">{{item.branchName}}</option>
                      </select>
                    <div class="text-danger" v-if="branchError">
                      <em>{{ branchError }}</em>
                    </div>
                  </div>
                    <div class="form-group mb-3">
                      <label>Role Name</label>
                      <div class="input-group">
                        <input
                          type="text"
                          placeholder="Enter Role Name"
                          class="form-control"
                          v-model="data.name" 
                          @input="resetError"
                        />
                      </div>
                      <div class="text-danger" v-if="nameError">
                        <em>{{ nameError }}</em>
                      </div>
                    </div>
                    <div class="form-group" v-if="GetAdminUser == userid">
                      <label class="col-form-label">Branch</label>
                      <model-list-select
                        :list="GetBranch ? GetBranch : []"
                        v-model="data.branch_id"
                        option-value="Id"
                        option-text="branchName"
                        placeholder="Select Branch"
                      >
                      </model-list-select>
                    </div>
                    <div class="text-danger" v-if="nameError">
                        <em>{{ branchError }}</em>
                    </div>
                    <div class="modal-footer">
                      <button
                        type="button"
                        class="btn btn-danger"
                        data-dismiss="modal"
                        @click="closeModal('add-role-modal')"
                      >
                        <i class="fa fa-times"></i> Close
                      </button>
                      <button
                        type="button"
                        class="btn btn-primary"
                        @click="addRole('add-role-modal')"
                      >
                        <i class="fa fa-check"></i>
                        Submit
                        <b-spinner
                          v-if="USER_SAVING"
                          variant="light"
                          small
                          label="Spinning"
                        ></b-spinner>
                      </button>
                    </div>
                  </b-modal>
                  <!-- modal ends -->
                </div>
              </div>
            </div>
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="ROLES ? ROLES : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(role_field)="data">
                  {{ data.item.roleName }} - {{ data.item.Branch.branchName }}
                </template>
                <template #cell(actions)="data">
                  <b-button
                    size="sm"
                    variant="success"
                    class="m-2"
                    @click="viewRolePermissions(data.item)"
                    >View Permissions</b-button
                  >
                </template>
              </b-table>
              <div style="text-align: center;">
                <h3 v-if="!ROLES" class="text-primary">
                  <b-spinner class="m-0" variant="primary" role="status"></b-spinner>
                  Please wait...
                </h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
